export default function UpIncrementIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50195 13.2692L5.70269 10.0685C6.48374 9.2874 7.75007 9.2874 8.53112 10.0684L10.3176 11.855C11.0987 12.636 12.365 12.636 13.1461 11.855L16.3468 8.65424"
        stroke="#11A75C"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6157 7.50031H16.5001C17.0524 7.50031 17.5001 7.94802 17.5001 8.50031V10.3846"
        stroke="#11A75C"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
